import React, { useEffect, useState } from 'react'
import { GetAll_Period_Api } from '../../API/PeriodApi';
import { Select } from 'antd';
import { Option } from 'antd/es/mentions';
// ======================================================================
export const PeriodsCombo = ({
    setLoading,
    showMessage,
    onChange
}) => {
    // ======================================================================
    const [periods, setPeriods] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Period_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPeriods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            // showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const handleChange = (value) => {
        if (onChange) onChange(value);
    };
    // ======================================================================
    return (
        <Select
            style={{ width: '100%' }}
            placeholder={"همه دوره ها"}
            onChange={handleChange}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
        >
            <Option value={null}>
                {"همه دوره ها"}
            </Option>
            {periods.map((period, key) => (
                <Option key={key} value={period.id}>
                    {period.title}
                </Option>
            ))}
        </Select>
    )
}